import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField} from "@material-ui/core";
import {isEmpty, isFunction, isUndefined} from "lodash";
import React, {useMemo, useState} from "react";
import Button from "@material-ui/core/Button";
import {Row} from "antd";
import {nanoid} from "@reduxjs/toolkit";
import RemoveIcon from "@material-ui/icons/Remove";
import {useDispatch} from "react-redux";
import {createCategory, editCategory} from "../../../redux/slices/category";
import {toast} from "react-toastify";
import {LoadingButton} from "@mui/lab";
import useCallbackGuard from "../../../hooks/useCallbackGuard";

const getDummy = () => ({id: nanoid(), label: ''})

const formatSelected = (selected) => {
    return isUndefined(selected) ? null : {
        ...selected,
        children: selected?.children?.map(({id, key, label}) => ({label, id: key || id})) || []
    }
}

export default function NewCategory({open, onClose, selected}) {
    const isEditMode = Boolean(selected);

    const dispatch = useDispatch();
    const {callbackGuard} = useCallbackGuard();

    const formatted = useMemo(() => formatSelected(selected), [selected])

    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState(formatted?.label || '');
    const [subCategories, setSubCategories] = useState(formatted?.children || []);

    const handleClose = () => isFunction(onClose) && onClose()

    const handleMainCategoryChange = (label) => setCategory(label)

    const handleAddMoreSubcategories = () => {
        setSubCategories(isEmpty(subCategories) ? [getDummy()] : [...subCategories, getDummy()])
    }

    const handleSubCategoryLabelChange = (id, label) => {
        setSubCategories(subCategories.map(category => {
            return (category.id === id) ? {...category, label} : category;
        }))
    }

    const handleRemoveSubCategory = (id) => {
        setSubCategories(subCategories.filter(category => category.id !== id));
    }

    const handleSubmit = () => {
        const data = {
            id: formatted?.id || nanoid(),
            label: category,
            children: subCategories
        }

        setLoading(true)

        const callback = () => {

            toast.success(
                isEditMode
                    ? "La modification a ete bien effectuee"
                    : "La creation a ete bien effectuee"
            );

            callbackGuard(() => setLoading(false));

            handleClose();

        }

        isEditMode
            ? dispatch(editCategory(data, callback))
            : dispatch(createCategory(data, callback))
    }


    return (
        <Dialog open={open} onClose={handleClose}>

            <DialogTitle>
                {
                    isEditMode
                        ? 'Editer Categorie'
                        : 'Nouvelle Categorie'
                }
            </DialogTitle>

            <DialogContent>

                <TextField
                    label="Categorie principale"
                    variant="outlined"
                    value={category}
                    onChange={({target:{value}}) => handleMainCategoryChange(value)}
                />

                {
                    !isEmpty(category) && (
                        <>
                            {
                                !isEmpty(subCategories) && (
                                    <>

                                        <Row style={{marginTop: 20, marginBottom: 20}}>
                                            <b>Sous categories</b>
                                        </Row>

                                        {
                                            subCategories.map(({id, label}) => (
                                                <Row className='pl-4 mb-2' key={id}>
                                                    <TextField
                                                        // label="Sub Category label"
                                                        variant="outlined"
                                                        value={label}
                                                        onChange={({target:{value}})  => handleSubCategoryLabelChange(id,value)}
                                                    />
                                                    <IconButton onClick={() => handleRemoveSubCategory(id)}>
                                                        <RemoveIcon color='error'/>
                                                    </IconButton>
                                                </Row>
                                            ))
                                        }

                                    </>
                                )
                            }

                            <Row style={{display: 'grid', placeItems: 'center', marginTop: 15}}>
                                <Button color='primary' onClick={handleAddMoreSubcategories}>
                                    Ajouter une sous categorie
                                </Button>
                            </Row>
                        </>

                    )
                }

            </DialogContent>

            <DialogActions>
                <LoadingButton loading={loading} onClick={handleSubmit} color="primary" autoFocus>
                    Valider
                </LoadingButton>
            </DialogActions>

        </Dialog>
    )
}